const resultToInputs = [
  'centerline_speed',
  'column_diameter',
  'footprint_diameter',
  'nbr_windings',
  'drive_type',
  'brake',
  'ue_angular',
  'le_angular',
  'closure_gap_option',
];

export default resultToInputs;
